import fetch from "@/uilts/request";


export default {
    /**
     * 创建代扣
     */
    createOrder(data) {
        return fetch.post("Weizukeji/createOrder", data)
    },
    /**
     * 查询签署状态
     */
    querySignStatus(data) {
        return fetch.post("Weizukeji/querySignStatus", data)
    },
    /**
     * 解约申请列表
     * TODO: 接口路径自行修改
     */
    terminateList(data) {
        return fetch.post("Weizukeji/terminateApplyList", data)
    },
    /**
     * 解约申请审批
     */
    auditTerminateApply(data) {
        return fetch.post("Weizukeji/auditTerminateApply", data)
    },
    /**
     * 签署订单列表
     */
    signOrderList(data) {
        return fetch.post("Weizukeji/signOrderList", data)
    },
    /**
     * 获取签约链接二维码
     */
    getSignLinkQrCode(data) {
        return fetch.post("Weizukeji/getSignLinkQrCode", data)
    },
}
